export default __webpack_public_path__ + "static/media/rollandGarros.0989fd99.jpeg";